export const CONFIG = {
  defaultTenantId: 1,
  apiUrl: '/api',
  wsURL: '/ws/websocket/websocket',
  metadataPath: '/metadata',
  imagesUrl: 'assets/images/',
  i18nPath: 'assets/i18n/',
  duoScriptUrl: 'https://api.duosecurity.com/frame/hosted/Duo-Web-v2.min.js',
  dateFormat: 'yyyy-mm-dd',
  shortDateFormat: 'MM/DD/YYYY',
  dateTimeFormat: 'YYYY-MM-DD hh:mm:ss',
  dateTimeFormatAlternative: 'MM/DD/YYYY hh:mma',
  dateTimeDetailedFormat: 'MM/DD/YYYY hh:mm:ssa',
  dateWeekDay: 'dddd, LL',
  formatTZ: 'America/New_York',
  passwordPattern: '(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9]).{8,}',
  basicStringPattern: '[a-zA-Z ]+',
  storagePrefix: 'cci',
  defaultLang: 'en',
  defaultProfileImage: 'assets/images/default.jpg',
  authHeader: 'Authorization',
  authPreamble: 'Bearer ',
  authErrorCode: 'BUS_0001',
  twoFactorAuthErrorCode: 'BUS_0051',
  passwordExpiredErrorCode: 'BUS_0058',
  wsRetryTimeOut: 120000, // time in milliseconds equivalent to 2 minutes
  emapBundleFileExtension: 'eMapBundle',
  oAuth: {
    regular: {
      grantType: '',
      clientId: '',
      clientSecret: '',
      username: '',
      password: ''
    },
    twoFactor: {
      grantType: 'twoFactor',
      appName: 'duo',
      username: '',
      password: '',
      secretCode: ''
    },
    refreshToken: {
      grantType: 'refresh_token'
    },
  },
  select: {
    basic: {
      highlight: false,
      create: false,
      persist: true,
      plugins: ['dropdown_direction'],
      dropdownDirection: 'auto',
      labelField: 'name',
      valueField: 'id',
      searchField: ['name'],
      maxItems: 1
    },
    multiple: {
      highlight: false,
      plugins: ['dropdown_direction', 'remove_button'],
      dropdownDirection: 'auto',
      labelField: 'name',
      valueField: 'id',
      searchField: ['name'],
      maxItems: 100
    }
  },
  toggleSwitch: {
    activeColor: '#55C2C3',
    bgColor: '#F5F5F6',
    size: 'small'
  },
  uploadSettings: {
    allowedTypes: ['image/png', 'image/jpg', 'image/jpeg', 'image/gif', ''],
    maxFileSize: 200000000000
  },
  pagination: {
    allowedRanges: [{ range: 10 }, { range: 20 }, { range: 30 }, { range: 40 }, { range: 50 }, { range: 75 }, { range: 100 }],
    maxPaginationItems: 4,
    directionLinks: true,
    boundaryLinks: false,
    ellipses: true,
    rotate: true,
    size: '',
    singleLargePage: 200
  },
  bundleSettings: {
    fileExtension: 'xml'
  },
    calendarResultHeaderSortNames: ['SOURCECALENDAR', 'EVENTCREATED', 'EVENTCREATOR', 'EVENTORGANIZER', 'EVENTSTART', 'EVENTEND']
};
